import { render, staticRenderFns } from "./MessageChange.vue?vue&type=template&id=0622ba70&scoped=true&"
import script from "./MessageChange.vue?vue&type=script&lang=js&"
export * from "./MessageChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622ba70",
  null
  
)

export default component.exports